const isWindows = () => window.navigator.platform.indexOf('Win') > -1;

export const isSpecialKeyPressed = e => (isWindows() ? e.ctrlKey : e.metaKey);

export const SPECIAL_KEY_SYMBOL = isWindows() ? 'CTRL' : '⌘';
